import React from "react";
import ReactDOM from "react-dom";

import "./styles/index.scss";

// modules
import App from "./App";
import { startIosInputZoomGuard } from "mobile/iosInputZoom";

// iPhone at mobile width only: no zoom when a field takes focus. A no-op on desktop.
startIosInputZoomGuard();

ReactDOM.render(<App />, document.getElementById("root"));
